"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const icons_1 = require("../../../assets/icons");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const scale_1 = require("../../../utils/scale");
const react_native_hyperlink_1 = __importDefault(require("react-native-hyperlink"));
const FAQItem = (props) => {
    const { data } = props;
    const [isCollapsed, setCollapsed] = (0, react_1.useState)(true);
    const [height, setHeight] = (0, react_1.useState)(0);
    const animation = (0, react_1.useRef)(new react_native_1.Animated.Value(0)).current;
    const toggleCollapse = () => {
        const toValue = isCollapsed ? 1 : 0;
        react_native_1.Animated.timing(animation, {
            toValue,
            duration: 200,
            useNativeDriver: false,
        }).start(() => {
            setCollapsed(!isCollapsed);
        });
    };
    const onLayout = (event) => {
        const onLayoutHeight = event.nativeEvent.layout.height;
        if (onLayoutHeight > 0 && height !== onLayoutHeight) {
            setHeight(onLayoutHeight);
        }
    };
    const containerStyle = {
        height: animation.interpolate({
            inputRange: [0, 1],
            outputRange: [0, height],
        }),
    };
    return (react_1.default.createElement(react_native_1.View, { style: styles.collapseItem },
        react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.collapseHeader, onPress: toggleCollapse },
            react_1.default.createElement(react_native_1.View, { style: { flex: 1, flexDirection: 'row' } },
                react_1.default.createElement(CustomText_1.default, { weight: '600', style: [styles.title1, { flex: undefined }] }, "Q."),
                react_1.default.createElement(CustomText_1.default, { weight: '600', style: styles.title2 }, data.title)),
            react_1.default.createElement(react_native_1.View, { style: isCollapsed ? styles.arrowDown : styles.arrowUp },
                react_1.default.createElement(icons_1.IC_ARROW_RIGHT, { width: (0, scale_1.scale)(14), height: (0, scale_1.scale)(14), color: '#36363e' }))),
        react_1.default.createElement(react_native_1.Animated.View, { style: [{ overflow: 'hidden' }, containerStyle] },
            react_1.default.createElement(react_native_1.View, { style: [styles.contentView], onLayout: onLayout },
                react_1.default.createElement(CustomText_1.default, { style: styles.content }, "A."),
                react_1.default.createElement(CustomText_1.default, { style: [styles.content, { flex: 1 }] },
                    !!data.highlightContent && (react_1.default.createElement(CustomText_1.default, { weight: '600', style: styles.highlightContent }, data.highlightContent)),
                    !!data.subContent && (react_1.default.createElement(react_native_1.Text, null, data.subContent)),
                    data.lines.map((item, index) => (react_1.default.createElement(react_native_1.View, { style: styles.row, key: index },
                        react_1.default.createElement(react_native_1.View, null,
                            react_1.default.createElement(CustomText_1.default, { style: styles.content }, " \u22C5  ")),
                        react_1.default.createElement(CustomText_1.default, { style: styles.content }, item)))),
                    !!data.link && (react_1.default.createElement(react_native_hyperlink_1.default, { linkDefault: true, linkStyle: [styles.link] },
                        react_1.default.createElement(CustomText_1.default, null, data.link))))))));
};
exports.default = FAQItem;
const styles = react_native_1.StyleSheet.create({
    collapseItem: {
        width: "100%",
    },
    row: {
        flexDirection: 'row',
        alignContent: 'flex-start',
        marginTop: (0, scale_1.scale)(2),
    },
    collapseHeader: {
        width: '100%',
        paddingVertical: (0, scale_1.scale)(12),
        paddingHorizontal: (0, scale_1.scale)(16),
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#EDEDED',
        borderBottomWidth: (0, scale_1.scale)(1),
        borderColor: '#DDDDDD'
    },
    title1: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33'
    },
    title2: {
        flex: 1,
        marginRight: (0, scale_1.scale)(24),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33'
    },
    arrowUp: {
        transform: [{ rotate: '-90deg' }]
    },
    arrowDown: {
        transform: [{ rotate: '90deg' }]
    },
    contentView: {
        flexDirection: 'row',
        paddingVertical: (0, scale_1.scale)(12),
        paddingHorizontal: (0, scale_1.scale)(16),
        borderBottomWidth: (0, scale_1.scale)(1),
        borderColor: '#DDDDDD'
    },
    highlightContent: {
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#292A33',
    },
    content: {
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
        color: '#292A33',
    },
    link: {
        textDecorationLine: "underline",
        color: '#007AFF',
        fontSize: (0, scale_1.moderateScale)(15),
        lineHeight: (0, scale_1.moderateScale)(22.5),
    }
});
